import React, { useEffect, useRef } from 'react';
import './Banner.css'; // Import CSS for Banner component

interface BannerProps {
  pageTitle: string;
  imageUrl: string;
}

const Banner: React.FC<BannerProps> = ({ pageTitle, imageUrl }) => {
  // Explicitly stating that the ref will be for an HTMLElement
  const bannerRef = useRef<HTMLElement>(null);

  useEffect(() => {

    const handleScroll = () => {
        if (bannerRef.current) {
          // Calculate the slow scroll effect, the '0.5' factor can be adjusted
          const offset = window.pageYOffset * 0.5;
          // Maintain horizontal centering, adjust vertical position based on scroll
          bannerRef.current.style.backgroundPosition = `center calc(40% + ${offset}px)`;
        }
      };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header ref={bannerRef} className="banner-container" style={{ backgroundImage: `url(${imageUrl})` }}>
      <div className="banner-content">
        <h1 className='display-1'>{pageTitle}</h1>
      </div>
    </header>
  );
}

export default Banner;
